export default __webpack_public_path__ + "static/media/OttawaIPadImg.cf97ed12.png";